import { Routes } from '@angular/router';
import { HomeComponent } from './components/core/home/home.component';
import { autoLoginPartialRoutesGuard } from 'angular-auth-oidc-client';
import { UnauthorizedComponent } from './components/core/unauthorized/unauthorized.component';
import { WelcomeComponent } from './components/core/welcome/welcome.component';
import { CanDeactivateFn } from '@angular/router';
import { CanComponentDeactivate } from './shared/components/navigation-guard-base/navigation-guard-base.component';

export const canDeactivateGuard: CanDeactivateFn<CanComponentDeactivate> = (component) => {
  return component.canDeactivate ? component.canDeactivate() : true;
};

export const routes: Routes = [
  { path: '', pathMatch: 'full', redirectTo: 'patient/dashboard' },
  {
    path: 'unauthorized', component: UnauthorizedComponent
  },
  {
    path: 'welcome', component: WelcomeComponent
  },
  { path: 'system/active-user', component: HomeComponent, canActivate: [autoLoginPartialRoutesGuard] },
  {
    path:  'system/audit-logs',
    loadComponent: () => import('./components/system/audit-logs/audit-logs.component').then(c => c.AuditLogsComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'system/hospitals',
    loadComponent: () => import('./components/system/hospital/hospital.component').then(c => c.HospitalComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'system/cost-centres',
    loadComponent: () => import('./components/system/cost-centre/cost-centre.component').then(c => c.CostCentreComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'system/departments',
    loadComponent: () => import('./components/system/department/department.component').then(c => c.DepartmentComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'system/races',
    loadComponent: () => import('./components/system/race/race.component').then(c => c.RaceComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'system/languages',
    loadComponent: () => import('./components/system/language/language.component').then(c => c.LanguageComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'system/translations',
    loadComponent: () => import('./components/system/translation/translation.component').then(c => c.TranslationComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'system/document-types',
    loadComponent: () => import('./components/system/document-type/document-type.component').then(c => c.DocumentTypeComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'system/access-control-lists',
    loadComponent: () => import('./components/system/access-control-list/access-control-list.component').then(c => c.AccessControlListComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'system/access-control-list-groups',
    loadComponent: () => import('./components/system/access-control-list-group/access-control-list-group.component').then(c => c.AccessControlListGroupGroupComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'system/roles',
    loadComponent: () => import('./components/system/role/role.component').then(c => c.RoleComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'system/users',
    loadComponent: () => import('./components/system/user/user.component').then(c => c.UserComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'system/locations',
    loadComponent: () => import('./components/system/location/location.component').then(c => c.LocationComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'system/notifications',
    loadComponent: () => import('./components/system/notification/notification.component').then(c => c.NotificationComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
   {
    path:  'system/bulk-upserts/:id',
    loadComponent: () => import('./components/system/bulk-upsert/bulk-upsert.component').then(c => c.BulkUpsertComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'user-profile',
    loadComponent: () => import('./components/core/user-profile/user-profile.component').then(c => c.UserProfileComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'samples/claims',
    loadComponent: () => import('./components/samples/claims/claims.component').then(c => c.ClaimsComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'samples/people',
    loadComponent: () => import('./components/samples/people/people.component').then(c => c.PeopleComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/meal-classes',
    loadComponent: () => import('./components/patient/meal-class/meal-class.component').then(c => c.MealClassComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/meal-periods',
    loadComponent: () => import('./components/patient/meal-period/meal-period.component').then(c => c.MealPeriodComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/dish-types',
    loadComponent: () => import('./components/patient/dish-type/dish-type.component').then(c => c.DishTypeComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/dish-tags',
    loadComponent: () => import('./components/patient/dish-tag/dish-tag.component').then(c => c.DishTagComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/bulk-meal-categories',
    loadComponent: () => import('./components/patient/bulk-meal-category/bulk-meal-category.component').then(c => c.BulkMealCategoryComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/treatment-categories',
    loadComponent: () => import('./components/patient/treatment-category/treatment-category.component').then(c => c.TreatmentCategoryComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/feedback-questionnaires',
    loadComponent: () => import('./components/patient/questionnaire/questionnaire.component').then(c => c.QuestionnaireComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/kitchen-sections',
    loadComponent: () => import('./components/patient/kitchen-section/kitchen-section.component').then(c => c.KitchenSectionComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/general-remarks',
    loadComponent: () => import('./components/patient/general-remark/general-remark.component').then(c => c.GeneralRemarkComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path: 'patient/market-lists',
    loadComponent: () => import('./components/patient/market-list/market-list.component').then(c => c.MarketListComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/restriction-types',
    loadComponent: () => import('./components/patient/restriction-type/restriction-type.component').then(c => c.RestrictionTypeComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/restrictions',
    loadComponent: () => import('./components/patient/restriction/restriction.component').then(c => c.RestrictionComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/disciplines',
    loadComponent: () => import('./components/patient/discipline/discipline.component').then(c => c.DisciplineComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/dish-group',
    loadComponent: () => import('./components/patient/dish-group/dish-group.component').then(c => c.DishGroupComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'catering/catering-dish-types',
    loadComponent: () => import('./components/catering/catering-dish-type/catering-dish-type.component').then(c => c.CateringDishTypeComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'catering/catering-dish-tags',
    loadComponent: () => import('./components/catering/catering-dish-tag/catering-dish-tag.component').then(c => c.CateringDishTagComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/meal-order-cut-offs',
    loadComponent: () => import('./components/patient/meal-order-cut-off/meal-order-cut-off.component').then(c => c.MealOrderCutOffComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/kitchen-tv-dashboard-settings',
    loadComponent: () => import('./components/patient/kitchen-tv-dashboard-settings/kitchen-tv-dashboard-settings.component').then(c => c.KitchenTvDashboardSettingsComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/plating-belt-settings',
    loadComponent: () => import('./components/patient/plating-belt-settings/plating-belt-settings.component').then(c => c.PlatingBeltSettingsComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'catering/catering-kitchen-sections',
    loadComponent: () => import('./components/catering/catering-kitchen-section/catering-kitchen-section.component').then(c => c.CateringKitchenSectionComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'catering/catering-payment-modes',
    loadComponent: () => import('./components/catering/catering-payment-mode/catering-payment-mode.component').then(c => c.CateringPaymentModeComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'catering/catering-event-types',
    loadComponent: () => import('./components/catering/catering-event-type/catering-event-type.component').then(c => c.CateringEventTypeComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'catering/catering-internal-orders',
    loadComponent: () => import('./components/catering/catering-internal-order/catering-internal-order.component').then(c => c.CateringInternalOrderComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/inventories',
    loadComponent: () => import('./components/inventory/inventory-list/inventory-list.component').then(c => c.InventoryListComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/purchase-orders',
    loadComponent: () => import('./components/inventory/inventory-purchase-order/inventory-purchase-order.component').then(c => c.InventoryPurchaseOrderComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/goods-receivings',
    loadComponent: () => import('./components/inventory/inventory-goods-receiving-list/inventory-goods-receiving-list.component').then(c => c.InventoryGoodsReceivingListComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/goods-returns',
    loadComponent: () => import('./components/inventory/inventory-goods-returns-list/inventory-goods-returns-list.component').then(c => c.InventoryGoodsReturnsListComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/requisitions',
    loadComponent: () => import('./components/inventory/inventory-requisition-list/inventory-requisition-list.component').then(c => c.InventoryRequsitionListComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/stocks-returns',
    loadComponent: () => import('./components/inventory/inventory-stocks-returns-list/inventory-stocks-returns-list.component').then(c => c.InventoryStocksReturnsListComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/transaction-logs',
    loadComponent: () => import('./components/inventory/inventory-transaction-log-list/inventory-transaction-log-list.component').then(c => c.InventoryTransactionLogListComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/stock-take',
    loadComponent: () => import('./components/inventory/inventory-stock-take-list/inventory-stock-take-list.component').then(c => c.InventoryStockTakeListComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/item-categories',
    loadComponent: () => import('./components/inventory/item-category/item-category.component').then(c => c.ItemCategoryComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/unit-of-measures',
    loadComponent: () => import('./components/inventory/unit-of-measure/unit-of-measure.component').then(c => c.UnitOfMeasureComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/items',
    loadComponent: () => import('./components/inventory/item/item.component').then(c => c.ItemComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/market-lists',
    loadComponent: () => import('./components/inventory/market-list/market-list.component').then(c => c.MarketListComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/suppliers',
    loadComponent: () => import('./components/inventory/supplier/supplier.component').then(c => c.SupplierComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/supplier-orders',
    loadComponent: () => import('./components/inventory/inventory-supplier-order/inventory-supplier-order.component').then(c => c.InventorySupplierOrderComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/settings',
    loadComponent: () => import('./components/inventory/setting/setting.component').then(c => c.SettingComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/ingredient-transaction-reports',
    loadComponent: () => import('./components/inventory/report-ingredient-transaction/report-ingredient-transaction.component').then(c => c.ReportIngredientTransactionComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/food-consumption-reports',
    loadComponent: () => import('./components/inventory/report-food-consumption/report-food-consumption.component').then(c => c.ReportFoodConsumptionComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'inventory/confirmed-food-issue-reports',
    loadComponent: () => import('./components/inventory/report-confirmed-food-issue/report-confirmed-food-issue.component').then(c => c.ReportConfirmedFoodIssueComponent),
    canActivate: [autoLoginPartialRoutesGuard],
    canDeactivate: [canDeactivateGuard]
  },
  {
    path:  'patient/order-completeness',
    loadComponent: () => import('./components/patient/meal-order-condition/meal-order-condition.component').then(c => c.MealOrderConditionComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/extra-orders',
    loadComponent: () => import('./components/patient/snack/snack.component').then(c => c.SnackComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'catering/catering-dishes',
    loadComponent: () => import('./components/catering/catering-dish/catering-dish.component').then(c => c.CateringDishComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'catering/catering-dish-sets',
    loadComponent: () => import('./components/catering/catering-dish-set/catering-dish-set.component').then(c => c.CateringDishSetComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'catering/catering-menus',
    loadComponent: () => import('./components/catering/catering-menu/catering-menu.component').then(c => c.CateringMenuComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'catering/catering-menu-cycles',
    loadComponent: () => import('./components/catering/catering-menu-cycle/catering-menu-cycle.component').then(c => c.CateringMenuCycleComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'catering/catering-settings',
    loadComponent: () => import('./components/catering/catering-settings/catering-settings.componet').then(c => c.CateringSettingsComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/dishes',
    loadComponent: () => import('./components/patient/dish/dish.component').then(c => c.DishComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/menus',
    loadComponent: () => import('./components/patient/menu/menu.component').then(c => c.MenuComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/menu-cycles',
    loadComponent: () => import('./components/patient/cycle/cycle.component').then(c => c.CycleComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/dashboard',
    loadComponent: () => import('./components/patient/patient-dashboard/patient-dashboard.component').then(c => c.PatientDashboardComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'pantry-requisition',
    loadComponent: () => import('./components/patient/pantry-requisition/pantry-requisition.component').then(c => c.PantryRequisitionComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/bulk-menu-cycles',
    loadComponent: () => import('./components/patient/bulk-menu-cycle/bulk-menu-cycle.component').then(c => c.BulkMenuCycleComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/bulk-orders',
    loadComponent: () => import('./components/patient/bulk-order/bulk-order.component').then(c => c.BulkOrderComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'hl7/queues',
    loadComponent: () => import('./components/hl7/queue/queue.component').then(c => c.QueueComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'hl7/completed-queues',
    loadComponent: () => import('./components/hl7/completed/completed.component').then(c => c.QueueCompletedComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'hl7/error-queues',
    loadComponent: () => import('./components/hl7/error/queue-error.component').then(c => c.QueueErrorComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'hl7/mappings',
    loadComponent: () => import('./components/hl7/mapping/mapping.component').then(c => c.MappingComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/meal-order-summary-reports',
    loadComponent: () => import('./components/patient/meal-order-summary-report/meal-order-summary-report.component').then(c => c.MealOrderSummaryReportComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/consolidated-meal-order-reports',
    loadComponent: () => import('./components/patient/report-consolidated-meal-order/report-consolidated-meal-order.component').then(c => c.ReportConsolidatedMealOrderComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
    {
    path:  'patient/extra-order-summary-reports',
    loadComponent: () => import('./components/patient/extra-order-summary-report/extra-order-summary-report.component').then(c => c.ExtraOrderSummaryReportComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },{
    path:  'patient/extra-order-detail-reports',
    loadComponent: () => import('./components/patient/extra-order-detail-report/extra-order-detail-report.component').then(c => c.ExtraOrderDetailReportComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/companion-meal-order-report',
    loadComponent: () => import('./components/patient/companion-meal-order-report/companion-meal-order-report.component').then(c => c.CompanionMealOrderReportComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/bulk-meal-order-reports',
    loadComponent: () => import('./components/patient/bulk-meal-order-report/bulk-meal-order-report.component').then(c => c.BulkMealOrderReportComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/therapeutic-diet-population-reports',
    loadComponent: () => import('./components/patient/report-therapeutic-diet-population/report-therapeutic-diet-population.component').then(c => c.ReportTherapeuticDietPopulationComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/meal-order-amendment-reports',
    loadComponent: () => import('./components/patient/meal-order-amendment-report/meal-order-amendment-report.component').then(c => c.MealOrderAmendmentReportComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/kitchen-dashboards',
    loadComponent: () => import('./components/patient/kitchen-dashboard/kitchen-dashboard.component').then(c => c.KitchenDashboardComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'catering/catering-event',
    loadComponent: () => import('./components/catering/catering-event/catering-event.component').then(c => c.CateringEventComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'catering/catering-orders',
    loadComponent: () => import('./components/catering/catering-orders/catering-orders.component').then(c => c.CateringOrdersComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'catering/catering-summary-report',
    loadComponent: () => import('./components/catering/report-catering-summary/report-catering-summary.component').then(c => c.ReportCateringSummaryComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/non-selection-report',
    loadComponent: () => import('./components/patient/non-selection-report/non-selection-report.component').then(c => c.NonSelectionReportComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/free-text-report',
    loadComponent: () => import('./components/patient/report-free-text-report/report-free-text-report.component').then(c => c.FreeTextReportComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/diet-board-report',
    loadComponent: () => import('./components/patient/diet-board-report/diet-board-report.component').then(c => c.DietBoardReportComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/meal-consumption-report',
    loadComponent: () => import('./components/patient/report-meal-consumption/report-meal-consumption.component').then(c => c.ReportMealConsumptionComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/meal-served-breakdown-report',
    loadComponent: () => import('./components/patient/report-meal-served-breakdown/report-meal-served-breakdown.component').then(c => c.ReportMealServedBreakdownComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/collation-meal-order-report',
    loadComponent: () => import('./components/patient/report-collation-meal-order/report-collation-meal-order.component').then(c => c.ReportCollationMealOrderComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/pantry-requisition-summary-report',
    loadComponent: () => import('./components/patient/report-pantry-requisition-summary/report-pantry-requisition-summary.component').then(c => c.ReportPantryRequisitionSummaryComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/pantry-requisition-detail-report',
    loadComponent: () => import('./components/patient/report-pantry-requisition-detail/report-pantry-requisition-detail.component').then(c => c.ReportPantryRequisitionDetailComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/tea-break-forecast-report',
    loadComponent: () => import('./components/patient/report-tea-break-forecast/report-tea-break-forecast.component').then(c => c.ReportTeaBreakForecastComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'public/tv-dashboard',
    loadComponent: () => import('./components/public/kitchen-tv-dashboard/kitchen-tv-dashboard.component').then(c => c.KitchenTvDashboardComponent)
  },
  {
    path:  'public/kitchen-tv-dashboard',
    redirectTo: 'public/tv-dashboard',
    pathMatch: 'full'
  },
  {
    path:  'patient/fruit-desert-report',
    loadComponent: () => import('./components/patient/report-fruit-desert/report-fruit-desert.component').then(c => c.ReportFruitDesertComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/special-request-report',
    loadComponent: () => import('./components/patient/report-special-request/report-special-request.component').then(c => c.ReportSpecialRequestComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/collation-report',
    loadComponent: () => import('./components/patient/report-collation/report-collation.component').then(c => c.ReportCollationComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/tea-snack-report',
    loadComponent: () => import('./components/patient/report-tea-snack/report-tea-snack.component').then(c => c.ReportTeaSnackComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/patient-movement-report',
    loadComponent: () => import('./components/patient/patient-movement-report/patient-movement-report.component').then(c => c.PatientMovementReportComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/beverage-summary-report',
    loadComponent: () => import('./components/patient/report-beverage-summary/report-beverage-summary.component').then(c => c.ReportBeverageSummaryComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/patient-count-report',
    loadComponent: () => import('./components/patient/report-patient-count/report-patient-count.component').then(c => c.ReportPatientCountComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/user-access-report',
    loadComponent: () => import('./components/patient/report-user-access/report-user-access.component').then(c => c.ReportUserAccessComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/birthday-cake-order-report',
    loadComponent: () => import('./components/patient/report-birthday-cake/report-birthday-cake.component').then(c => c.ReportBirthdayCakeComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/postnatal-report',
    loadComponent: () => import('./components/patient/report-postnatal/report-postnatal.component').then(c => c.ReportPostnatalComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/simple-birthday-cake-report',
    loadComponent: () => import('./components/patient/report-simple-birthday-cake/report-simple-birthday-cake.component').then(c => c.ReportSimpleBirthdayCakeComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path: 'patient/consolidated-feedback-report',
    loadComponent: () => import('./components/patient/consolidated-feedback-report/consolidated-feedback-report.component').then(c => c.ConsolidatedFeedbackReport),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/food-costing-report',
    loadComponent: () => import('./components/patient/report-food-costing/report-food-costing.component').then(c => c.ReportFoodCostingComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/dish-feedback-report',
    loadComponent: () => import('./components/patient/dish-feedback-report/dish-feedback-report.components').then(c => c.ReportDishFeedback),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/user-ordered-report',
    loadComponent: () => import('./components/patient/report-user-ordered/report-user-ordered.component').then(c => c.ReportUserOrderedComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
  {
    path:  'patient/plating-belt-report',
    loadComponent: () => import('./components/patient/report-plating-belt/report-plating-belt.component').then(c => c.ReportPlatingBeltComponent),
    canActivate: [autoLoginPartialRoutesGuard]
  },
];
